import BaseSection from '@/sections/base'

export default class MainAboutSection extends BaseSection {
  static TYPE = 'main-about'
}
